module.exports = __webpack_public_path__ + "img/MSLNG1_Cover.d1df209e.jpg";